// extracted by mini-css-extract-plugin
export default {"backgroundImageWrapper":"HomePage_backgroundImageWrapper__L4xrQ","backgroundColorWrapper":"HomePage_backgroundColorWrapper__XrrAR"};